console.log('From article teaser component!!!');